'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Notification = require('../Notification/Notification.js');

/* eslint-disable import/no-mutable-exports */
var defaultHandler = {
    notification: null,
    addNotification: function () { },
    removeNotification: function () { },
};
var NotificationContext = React__default.createContext(defaultHandler);
exports.addNotification = function () { };
function NotificationProvider(_a) {
    var children = _a.children;
    var _b = React.useState(null), notification = _b[0], setNotification = _b[1];
    var removeNotification = function () { return setNotification(null); };
    exports.addNotification = function (noti) {
        setNotification(noti);
    };
    var contextValue = {
        notification: notification,
        addNotification: React.useCallback(function (noti) {
            exports.addNotification(noti);
        }, []),
        removeNotification: React.useCallback(function () { return removeNotification(); }, []),
    };
    return (React__default.createElement(NotificationContext.Provider, { value: contextValue },
        children,
        React__default.createElement(Notification, null)));
}
var NotificationProvider$1 = { NotificationProvider: NotificationProvider, addNotification: exports.addNotification };

exports.NotificationContext = NotificationContext;
exports.default = NotificationProvider$1;
